import { ROUTES } from '@/app/lib/constants'
import { ICategoryWithSubcategoriesHit } from '@/types/search'
import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useHits } from 'react-instantsearch'
import { ImageWithFallback } from '../../shared/components/image-with-fallback'

export function CategoriesShowcase() {
  const t = useTranslations('CategoriesShowcase')
  const { items: categories = [] } = useHits<ICategoryWithSubcategoriesHit>()

  if (categories.length === 0) {
    return null
  }

  return (
    <section
      className="rounded-xl bg-mydra-black p-10 text-white"
      style={
        {
          '--item-x-gap': '36px',
        } as React.CSSProperties
      }
    >
      <Typography variant="h1" className="text-white">
        {t('dive_deeper_into_your_topics')}
      </Typography>
      <Typography variant="body1" className="mt-2 text-white">
        {t('learn_how_ai_applies')}
      </Typography>
      <ul className="mt-8 grid grid-cols-2 content-center justify-center gap-x-[var(--item-x-gap)] gap-y-9 md:grid-cols-3 lg:grid-cols-5">
        {categories.map((category) => (
          <Link
            key={category.id}
            href={`${ROUTES.category.replace(':slug', category.slug)}`}
            className="overflow-hidden rounded-xl border border-lines/50"
          >
            <div className="relative aspect-[1.6] rounded-xl">
              <div className="absolute inset-0">
                <ImageWithFallback
                  alt={category.name}
                  src={`/images/taxonomy-images/card-${category.slug}.jpg`}
                  fallbackSrc="/images/taxonomy-images/card-fallback.jpg"
                  width={3000}
                  height={1327}
                  className="absolute z-0 h-full w-full bg-mydra-black object-cover"
                />
              </div>
              <Typography className="absolute bottom-6 left-6 font-title text-3xl leading-tight text-white">
                {category.name}
              </Typography>
            </div>
          </Link>
        ))}
      </ul>
    </section>
  )
}
